import React, { useRef } from 'react'
import { BreathAPIs } from '../APIs/BreathAPIs';
import { toast, ToastContainer } from 'react-toastify';
import { connect } from 'react-redux';
import Booking from './Booking';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types'
import styles from './style.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/free-solid-svg-icons';
import LoadingBooking from './LoadingBooking';
import { ButtonCustom } from '../BootstrapComponents/ButtonCustom';
import { useLocation, useNavigate } from 'react-router-dom';
import { HiRefresh } from "react-icons/hi";
import { useWebSocket } from '../Utils/WebSocketContext';



const Bookings = ({ userID, user, timeFormatAmPm, type, edrvID, jwt, csmsID, walletAmount, isAutoPayEnabled, isUserTester, isGuest }) => {

  const [isLoading, setIsLoading] = useState(true);
  const [contentRefreshing, setContentRefreshing] = useState(false);
  const [historyRefreshing, setHistoryRefreshing] = useState(false);

  const [isHistoryLoading, setIsHistoryLoading] = useState(false);
  const [isHistoryLoadingButton, setIsHistoryLoadingButton] = useState(false);

  const [history, setHistory] = useState([]);


  const [bookings, setBookings] = useState({
    future: [],
    current: [],
  });

  const [totalHistoryCount, setTotalHistoryCount] = useState(0);
  const [historyPageNumber, setHistoryPageNumber] = useState(1);
  const [showLoadMoreButton, setShowLoadMoreButton] = useState(true);

  const location = useLocation();
  const navigate = useNavigate();
  const bookingSuccess = location.state ? location.state.bookingSuccess : false;

  const bookingRef = useRef();

  const webSocket = useWebSocket();

  useEffect(()=>{
    if(webSocket){
      webSocket.addEventListener('message', function (event) {
        if (JSON.parse(event.data).type === "refetch_booking") {
          setTimeout(()=>{
            handleRefresh()
          },1000)
          
        }
      })
    }else{
      console.log('no websocket')
    }
  },[webSocket])

  useEffect(() => {
    if (bookingSuccess) {
      toast.success('Booking successful!');
      navigate({ ...location, state: undefined });
    }
  }, [])

  useEffect(() => {

    if (userID) {
      fetchData()
      if (!isGuest) {
        fetchHistory();
      }
    }

  }, [userID])


  if (!userID) {
    return (<div className={styles.spinner}>
      <FontAwesomeIcon icon={faBolt} size="3x" />
    </div>)
  }



  const fetchHistory = async (btnLoad = false, fetchFirstPage = false) => {
    try {
      btnLoad ? setIsHistoryLoadingButton(true) : setIsHistoryLoading(true);

      const pageSize = 7;
      const res = fetchFirstPage ? await BreathAPIs.getBookingHistory(1, pageSize) : await BreathAPIs.getBookingHistory(historyPageNumber, pageSize);
      setHistoryPageNumber(fetchFirstPage ? 2 : historyPageNumber + 1);

      btnLoad ? setIsHistoryLoadingButton(false) : setIsHistoryLoading(false);

      const mergedBookings = fetchFirstPage ? res.data?.bookings : [...history, ...(res.data?.bookings || [])];

      const uniqueIds = new Set();

      const uniqueBookings = mergedBookings.filter(booking => {
        if (!uniqueIds.has(booking?._id)) {
          uniqueIds.add(booking?._id);
          return true;
        }
        return false;
      });

      setHistory(uniqueBookings);

      if (uniqueBookings.length >= res.data?.total) {
        setShowLoadMoreButton(false);
      }
      else {
        setShowLoadMoreButton(true);
      }

      setTotalHistoryCount(res.data?.total);
    } catch (error) {
      setIsHistoryLoading(false);
      console.error('Error fetching booking history:', error.message);
    }
  };


  const fetchData = async () => {
    try {
      setIsLoading(true);
      const res = await BreathAPIs.getUpcomingBookings();
      const now = new Date();
      const categorizedBookings = res.data
        .reduce(
          (acc, booking) => {
            const startTime = new Date(booking.startTime);
            const endTime = new Date(booking.endTime);
            if ((endTime < now) && booking.bookingStatus === "Completed") {
              // acc.past.push(booking);
            } else if ((startTime <= now && endTime >= now) || booking.bookingStatus === "Idle") {
              // acc.future.unshift(booking); // Add to the beginning of the 'future' array
              acc.current.push(booking);
            } else if (startTime > now) {
              acc.future.push(booking);
            }
            return acc;
          },
          { future: [], current: [] }
        );

      // categorizedBookings.past = categorizedBookings.past.reverse();
      categorizedBookings.future = categorizedBookings.future.reverse();
      categorizedBookings.current = categorizedBookings.current.reverse();

      setBookings(categorizedBookings);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      toast.error('Failed to fetch bookings.');
    }


  };

  const handleCancel = async (id) => {
    try {
      const res = await BreathAPIs.cancelBooking(id);
      if (res.status === 200) {
        toast.success('Booking cancelled successfully');
      }

      // Re-fetch bookings data after a booking is cancelled.
      fetchData();
    } catch (error) {
      console.error(error);
      toast.error('We encountered an issue canceling your booking. Please try again or contact support for assistance.');
    }

  }


  const handleRefresh = async () => {
    setContentRefreshing(true);
    if(bookingRef.current){
      let ref = bookingRef.current.refreshInProgressItems
      ref()
    }
    await fetchData();
    setContentRefreshing(false);
  }

  const handleHistoryRefresh = async () => {
    setHistoryRefreshing(true);
    
    await fetchHistory(false, true);

    setHistoryRefreshing(false);
  }

  return (
    <div>
      <ToastContainer></ToastContainer>

      <div className="container">
        <div className={`${styles['booking-row']} ${isGuest ? styles['booking-row-guest'] : ''}`}>
          <div className={`${styles['booking-column']}`}>


            {(bookings.current.length ===0 && bookings.future.length ===0 ) && 
              <div>
                <div className={styles['upcoming-booking-header']}>
                  <h4 className={styles['booking-heading']}>Upcoming</h4>
                  {bookings.current.length === 0 && <div className={`${styles.refreshButton}`}>
                    <button onClick={handleRefresh} type='button'>
                      <HiRefresh className={contentRefreshing ? "spinner-border spinner-border-sm" : ""} />
                      {contentRefreshing ? 'Refreshing...' : 'Refresh'}
                    </button>
                  </div>}
                </div>
                <div className={styles['bookings']}>
                {isLoading && <LoadingBooking />}
                {(!isLoading) && <h2 className={styles['no-results']}>No Results</h2>}
                </div>
              </div>
            }

            {bookings.current.length !== 0 && <div>
              <div className={styles['upcoming-booking-header']}>
                <h4 className={styles['booking-heading']}>In-progress</h4>
               <div className={`${styles.refreshButton}`}>
                  <button onClick={handleRefresh} type='button'>
                    <HiRefresh className={contentRefreshing ? "spinner-border spinner-border-sm" : ""} />
                    {contentRefreshing ? 'Refreshing...' : 'Refresh'}
                  </button>
                </div>
              </div>
              <div className={styles['bookings-left']}>
                
                {isLoading && <LoadingBooking />}
                {(!isLoading && bookings.current.length === 0) && <h2 className={styles['no-results']}>No Results</h2>}
                {!isLoading && bookings.current.map((booking) => (
                  <Booking
                    currentBookingID={bookings.current.length !== 0 ? booking._id : ""}
                    key={booking._id}
                    bookingId={booking._id}
                    title="In-progress"
                    chargerTag={booking.charger.chargerTag}
                    chargerId={booking.charger._id}
                    bookingType={booking.bookingType}
                    freeChargingStartTime={booking.charger?.freeChargingComponent.startTime}
                    freeChargingEndTime={booking.charger?.freeChargingComponent.endTime}
                    startTime={booking.startTime}
                    endTime={booking.isNightCharging ? booking.endTimeOverNight : booking.endTime}
                    isFuture={true}
                    connector={booking.charger.connectionServer === "CSMS_BREATHE" ? booking.connector?.csmsBreatheID : booking.connector?.edrvID}
                    edrvID={booking.charger.connectionServer === "CSMS_BREATHE" ? csmsID : edrvID}
                    jwt={jwt}
                    onCancel={() => handleCancel(booking._id)}
                    ref={bookingRef}
                    // disable = {booking.sessions.length > 0 ? false: true}
                    bookingStatusString={booking.bookingStatus}
                    userID={userID}
                    location={booking.charger.location}
                    timeFormatAmPm={timeFormatAmPm}
                    unUtilizedFee={null}
                    idleDuration={null}
                    unUtilizedTimeSec={null}
                    bookingSubmitFeedBack={()=>{handleRefresh()}}
                    transactionStatus={booking.remoteTransactionStatus[booking.remoteTransactionStatus.length - 1]}
                    nonReservable = {booking.nonReservable}
                    createdAt = {booking.createdAt}
                    timeOfValidation = {booking.timeOfValidation}
                    fetchData={fetchData}
                    booking={booking}
                    endTimeScheduled={booking.endTimeScheduled}
                    gracePeriod={booking.gracePeriod}
                    estimateAmount={booking.estimateAmount}
                    connectorNumber={booking.connector.connectorNumber}
                    breatheConnectorId={booking.connector._id}
                    noOfConnectorsInCharger={booking.connector.noOfConnectorsInCharger}
                    autoPayFlag={booking.autoPayFlag}
                    walletAmount={walletAmount}
                    isAutoPayEnabled={isAutoPayEnabled}
                    isNightCharging={booking.isNightCharging}
                    nightChargeEndTime={booking.endTime}
                    isUserTester={isUserTester}
                  />
                ))}
              </div>
            </div>}


           {bookings.future.length !==0 && <div>
              <div className={styles['upcoming-booking-header']}>
                <h4 className={styles['booking-heading']}>Upcoming</h4>
                {bookings.current.length === 0 && <div className={`${styles.refreshButton}`}>
                  <button onClick={handleRefresh} type='button'>
                    <HiRefresh className={contentRefreshing ? "spinner-border spinner-border-sm" : ""} />
                    {contentRefreshing ? 'Refreshing...' : 'Refresh'}
                  </button>
                </div>}
              </div>
              
              <div className={bookings.current.length === 0 ? styles['bookings'] : styles['bookings-left']}>
                {isLoading && <LoadingBooking />}
                {(!isLoading && bookings.future.length === 0) && <h2 className={styles['no-results']}>No Results</h2>}
                {!isLoading && bookings.future.map((booking) => (
                  <Booking
                    key={booking._id}
                    currentBookingID={""}
                    bookingId={booking._id}
                    title="Upcoming Booking"
                    chargerTag={booking.charger.chargerTag}
                    chargerId={null}
                    startTime={booking.startTime}
                    endTime={booking.endTimeScheduled}
                    isFuture={true}
                    connector={booking.charger.connectionServer === "CSMS_BREATHE" ? booking.connector?.csmsBreatheID : booking.connector?.edrvID}
                    edrvID={booking.charger.connectionServer === "CSMS_BREATHE" ? csmsID : edrvID}
                    jwt={jwt}
                    onCancel={() => handleCancel(booking._id)}
                    ref={bookingRef}
                    // disable = {booking.sessions.length > 0 ? false: true}
                    userID={userID}
                    location={booking.charger.location}
                    timeFormatAmPm={timeFormatAmPm}
                    unUtilizedFee={null}
                    idleDuration={null}
                    unUtilizedTimeSec={null}
                    bookingStatusString={booking.bookingStatus}
                    bookingSubmitFeedBack={()=>{handleRefresh()}}
                    transactionStatus={booking.remoteTransactionStatus[booking.remoteTransactionStatus.length - 1]}
                    nonReservable = {booking.nonReservable}
                    createdAt = {booking.createdAt}
                    timeOfValidation = {booking.timeOfValidation}
                    earlyAccess = {booking.earlyAccess}
                    booking={booking}
                    fetchData={fetchData}
                    endTimeScheduled={booking.endTimeScheduled}
                    gracePeriod={booking.gracePeriod}
                    estimateAmount={booking.estimateAmount}
                    connectorNumber={booking.connector.connectorNumber}
                    breatheConnectorId={booking.connector._id}
                    noOfConnectorsInCharger={booking.connector.noOfConnectorsInCharger}
                    autoPayFlag={booking.autoPayFlag}
                    walletAmount={walletAmount}
                    isAutoPayEnabled={isAutoPayEnabled}
                    isNightCharging={booking.isNightCharging}
                    nightChargeEndTime={booking.endTime}
                    isUserTester={isUserTester}
                  />
                ))}
              </div>
            </div>}
          </div>


          {!isGuest && <div className={`${styles['booking-column']}`}>
            <div className={styles['upcoming-booking-header']}>
              <h4 className={styles['booking-heading']}>Booking History</h4>
              <div className={`${styles.refreshButton}`}>
                <button onClick={handleHistoryRefresh} type='button'>
                  <HiRefresh className={historyRefreshing ? "spinner-border spinner-border-sm" : ""} />
                  {historyRefreshing ? 'Refreshing...' : 'Refresh'}
                </button>
              </div>
            </div>

            <div className={styles['bookings']}>
              {isHistoryLoading && <LoadingBooking />}
              {(!isHistoryLoading && history?.length === 0) && <h2 className={styles['no-results']}>No Results</h2>}
              {!isHistoryLoading && history?.map((booking) => (
                <Booking
                  key={booking._id}
                  currentBookingID={""}
                  bookingId={booking._id}
                  title="Past Booking"
                  chargerTag={booking.charger.chargerTag}
                  chargerId={null}
                  startTime={booking.startTime}
                  endTime={booking.nonReservable ? booking.endTime : booking.endTimeScheduled  }
                  connector={booking.charger.connectionServer === "CSMS_BREATHE" ? booking.connector?.csmsBreatheID : booking.connector?.edrvID}
                  edrvID={booking.charger.connectionServer === "CSMS_BREATHE" ? csmsID : edrvID}
                  jwt={jwt}
                  userID={userID}
                  location={booking.charger.location}
                  timeFormatAmPm={timeFormatAmPm}
                  unUtilizedFee={booking.unUtilizedFee}
                  idleDuration={booking.IdleDuration}
                  unUtilizedTimeSec={booking.unUtilizedTime.paidTime}
                  transactionStatus={booking.remoteTransactionStatus[booking.remoteTransactionStatus.length - 1]}
                // disable = {booking.sessions.length > 0 ? false: true}
                  bookingStatusString={booking.bookingStatus}
                  nonReservable = {booking.nonReservable}
                  createdAt = {booking.createdAt}
                  timeOfValidation = {booking.timeOfValidation}
                  fetchData = {fetchData}
                  booking={booking}
                  endTimeScheduled={booking.endTimeScheduled}
                  gracePeriod={booking.gracePeriod}
                  estimateAmount={booking.estimateAmount}
                  connectorNumber={booking.connector.connectorNumber}
                  breatheConnectorId={booking.connector._id}
                  noOfConnectorsInCharger={booking.connector.noOfConnectorsInCharger}
                  autoPayFlag={booking.autoPayFlag}
                  walletAmount={walletAmount}
                  isAutoPayEnabled={isAutoPayEnabled}
                  isNightCharging={booking.isNightCharging}
                  nightChargeEndTime={booking.endTime}
                  isUserTester={isUserTester}
                /> 
              ))}
              {showLoadMoreButton && !isHistoryLoading &&
                <div className='text-center'>
                  <ButtonCustom style={{ padding: '2px 14px', fontSize: '14px', borderRadius: '13px' }} variant={"primary"} text={isHistoryLoadingButton ? 'loading...' : 'more'} isLoading={isHistoryLoadingButton} onClick={fetchHistory}></ButtonCustom>
                </div>
              }
            </div>
          </div>}

        </div>
      </div>
    </div>
  );
}

Bookings.propTypes = {
  user: PropTypes.string,
  timeFormatAmPm: PropTypes.bool,
  userID: PropTypes.string,
  location: PropTypes.string,
  type: PropTypes.string,
  edrvID: PropTypes.string,
  jwt: PropTypes.string,
  csmsID: PropTypes.string,
  walletAmount: PropTypes.number,
  isAutoPayEnabled: PropTypes.bool,
  isUserTester: PropTypes.bool
}
const mapStateToProps = state => ({
  user: state.auth && state.auth.user ? state.auth.user.firstName : null,
  timeFormatAmPm: state.auth && state.auth.user ? state.auth.user.timeFormatAmPm : false,
  userID: state.auth && state.auth.user ? state.auth.user._id : null,
  location: state.auth && state.auth.user ? state.auth.user.location._id : null,
  type: state.auth && state.auth.user ? state.auth.user.type : null,
  edrvID: state.auth && state.auth.user ? state.auth.user.edrvID : null,
  jwt: state.auth && state.auth.user ? state.auth.token : null,
  csmsID: state.auth && state.auth.user ? state.auth.user.csmsBreatheID : null,
  walletAmount: state.auth && state.auth.user ? state.auth.user.wallet.coins : null,
  isAutoPayEnabled: state.auth && state.auth.user ? state.auth.user.isAutoPayEnabled : false,
  isUserTester: state.auth && state.auth.user ? state.auth.user.isUserTester : false,
  isGuest: state.auth && state.auth.user ? state.auth.user.isGuest : false
  //isAuthenticated : state.auth.isAuthenticated,

})

export default connect(mapStateToProps, {})(Bookings)